import { z } from 'zod';
import { idInput, paginationInput } from './common';
import { patrocinadorTipoEnum, patrocinadorStatusEnum } from './eventos';

// Enums
export const naturezaEnum = z.enum(['RECEITA', 'DESPESA']);
export type Natureza = z.infer<typeof naturezaEnum>;

// Gabarito de Contas
export const createContaGabaritoInput = z.object({
  eventoId: z.string().uuid(),
  nome: z.string().min(2, 'Nome deve ter no mínimo 2 caracteres'),
  natureza: naturezaEnum,
});

export const updateContaGabaritoInput = idInput.extend({
  nome: z.string().min(2).optional(),
  natureza: naturezaEnum.optional(),
  parentId: z.string().uuid().nullable().optional(),
});

export const listContasGabaritoInput = paginationInput.extend({
  eventoId: z.string().uuid(),
});

// Lançamentos do Livro Caixa
export const createLancamentoInput = z.object({
  eventoId: z.string().uuid(),
  data: z.string(),
  contaGabaritoId: z.string().uuid('Selecione uma conta'),
  descricao: z.string().min(2, 'Descrição deve ter no mínimo 2 caracteres'),
  valor: z.string().min(1, 'Valor é obrigatório'),
  linkNotaFiscal: z.string().optional().or(z.literal('')),
  linkAnexo: z.string().optional().or(z.literal('')),
  // Campos extras para patrocínio
  patrocinadorNome: z.string().min(2, 'Nome deve ter no mínimo 2 caracteres').optional().or(z.literal('')),
  patrocinadorCnpjCpf: z.string().optional(),
  patrocinadorTipo: patrocinadorTipoEnum.optional(),
  patrocinadorStatus: patrocinadorStatusEnum.optional(),
});

export const updateLancamentoInput = idInput.extend({
  data: z.string().optional(),
  contaGabaritoId: z.string().uuid().optional(),
  descricao: z.string().min(2).optional(),
  valor: z.string().optional(),
  linkNotaFiscal: z.string().nullable().optional(),
  linkAnexo: z.string().nullable().optional(),
});

export const listLancamentosInput = paginationInput.extend({
  eventoId: z.string().uuid(),
  search: z.string().optional(),
  natureza: naturezaEnum.optional(),
  contaGabaritoId: z.string().uuid().optional(),
  origem: z.enum(['MANUAL', 'INSCRICAO', 'PATROCINIO', 'GASTO']).optional(),
});

// Views computadas
export const getBalanceteInput = z.object({
  eventoId: z.string().uuid(),
});

export const getSaldosDiariosInput = z.object({
  eventoId: z.string().uuid(),
});

export const exportLivroCaixaInput = z.object({
  eventoId: z.string().uuid(),
});

// Types
export type CreateContaGabaritoInput = z.infer<typeof createContaGabaritoInput>;
export type UpdateContaGabaritoInput = z.infer<typeof updateContaGabaritoInput>;
export type ListContasGabaritoInput = z.infer<typeof listContasGabaritoInput>;
export type CreateLancamentoInput = z.infer<typeof createLancamentoInput>;
export type UpdateLancamentoInput = z.infer<typeof updateLancamentoInput>;
export type ListLancamentosInput = z.infer<typeof listLancamentosInput>;
export type GetBalanceteInput = z.infer<typeof getBalanceteInput>;
export type GetSaldosDiariosInput = z.infer<typeof getSaldosDiariosInput>;
export type ExportLivroCaixaInput = z.infer<typeof exportLivroCaixaInput>;
